var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M122.149 120.787a5.215 5.215 0 01-7.177 1.737c-19.665-12.02-44.417-14.733-73.567-8.075a5.216 5.216 0 01-6.249-3.924 5.212 5.212 0 013.925-6.25c31.9-7.292 59.263-4.154 81.336 9.334a5.22 5.22 0 011.732 7.178m10.247-22.803c-1.894 3.073-5.912 4.037-8.98 2.149-22.504-13.833-56.822-17.841-83.447-9.759a6.539 6.539 0 01-8.148-4.35 6.538 6.538 0 014.354-8.142c30.415-9.23 68.226-4.76 94.074 11.125 3.068 1.891 4.034 5.911 2.147 8.977m.884-23.744c-26.993-16.031-71.52-17.505-97.289-9.684-4.139 1.256-8.515-1.08-9.768-5.218a7.835 7.835 0 015.22-9.772c29.582-8.979 78.755-7.245 109.832 11.202a7.831 7.831 0 012.737 10.733c-2.208 3.722-7.018 4.949-10.732 2.739"}));
}

Spotify.defaultProps = {"width":"167.487","height":"167.487","viewBox":"0 0 167.487 167.487"};

module.exports = Spotify;

Spotify.default = Spotify;
